import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "tx-pagehead" }
const _hoisted_2 = { class: "tx-inbox__list tx-card tx-card--flush" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "tx-row__main" }
const _hoisted_5 = {
  key: 0,
  class: "tx-count"
}
const _hoisted_6 = { class: "tx-inbox__thread tx-card" }
const _hoisted_7 = ["onSubmit"]
const _hoisted_8 = { class: "tx-field" }
const _hoisted_9 = { class: "tx-field" }
const _hoisted_10 = {
  key: 0,
  class: "tx-check"
}
const _hoisted_11 = { class: "tx-formactions" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "tx-thread__head" }
const _hoisted_14 = ["href"]
const _hoisted_15 = { class: "tx-muted" }
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "tx-actions" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  ref: "scroller",
  class: "tx-thread",
  "aria-live": "polite"
}
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = ["href"]
const _hoisted_23 = {
  key: 0,
  class: "tx-muted tx-pad"
}
const _hoisted_24 = ["onSubmit"]
const _hoisted_25 = ["placeholder", "aria-label", "onKeydown"]
const _hoisted_26 = { class: "tx-composer__bar" }
const _hoisted_27 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", null, _toDisplayString($setup.state.t("conv.title")), 1 /* TEXT */),
      _createElementVNode("button", {
        class: "tx-btn tx-btn--primary",
        onClick: $setup.startNew
      }, [
        _createVNode($setup["Icon"], {
          name: "plus",
          size: "16"
        }),
        _createTextVNode(_toDisplayString($setup.state.t("conv.new")), 1 /* TEXT */)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["tx-inbox", { 'tx-inbox--thread': $setup.activeId || $setup.composing }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode($setup["Loader"], {
          loading: $setup.loadingList,
          error: $setup.listError,
          onRetry: $setup.loadList
        }, {
          default: _withCtx(() => [
            (!$setup.list.length)
              ? (_openBlock(), _createBlock($setup["Empty"], {
                  key: 0,
                  icon: "chat"
                }))
              : _createCommentVNode("v-if", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (c) => {
              return (_openBlock(), _createElementBlock("a", {
                key: c.name,
                href: $setup.link('conversations/' + c.name),
                "data-nav": "",
                class: _normalizeClass(["tx-convitem", { on: c.name === $setup.activeId }])
              }, [
                _createElementVNode("span", _hoisted_4, [
                  _createElementVNode("strong", null, _toDisplayString(c.subject), 1 /* TEXT */),
                  _createElementVNode("small", null, [
                    (c.channel && c.channel !== 'Portal')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(c.channel) + " · ", 1 /* TEXT */)
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true),
                    _createTextVNode(_toDisplayString($setup.fmtDate(c.last_activity_at, true)), 1 /* TEXT */),
                    (c.helpdesk_ticket)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" · #" + _toDisplayString(c.helpdesk_ticket), 1 /* TEXT */)
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true)
                  ])
                ]),
                (c.unread)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(c.unread), 1 /* TEXT */))
                  : (_openBlock(), _createBlock($setup["Badge"], {
                      key: 1,
                      status: c.status
                    }, null, 8 /* PROPS */, ["status"]))
              ], 10 /* CLASS, PROPS */, _hoisted_3))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["loading", "error"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        ($setup.composing)
          ? (_openBlock(), _createElementBlock("form", {
              key: 0,
              class: "tx-form",
              onSubmit: _withModifiers($setup.create, ["prevent"])
            }, [
              _createElementVNode("button", {
                type: "button",
                class: "tx-backlink tx-only-sm",
                onClick: _cache[0] || (_cache[0] = $event => ($setup.composing = false))
              }, [
                _createVNode($setup["Icon"], {
                  name: "back",
                  size: "16"
                }),
                _createTextVNode(_toDisplayString($setup.state.t("common.back")), 1 /* TEXT */)
              ]),
              _createElementVNode("h2", null, _toDisplayString($setup.state.t("conv.new")), 1 /* TEXT */),
              _createElementVNode("label", _hoisted_8, [
                _createElementVNode("span", null, _toDisplayString($setup.state.t("conv.subject")), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.newSubject) = $event)),
                  required: "",
                  maxlength: "140"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, $setup.newSubject]
                ])
              ]),
              _createElementVNode("label", _hoisted_9, [
                _createElementVNode("span", null, _toDisplayString($setup.state.t("conv.message")), 1 /* TEXT */),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.newMessage) = $event)),
                  rows: "6",
                  required: "",
                  maxlength: "20000"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, $setup.newMessage]
                ])
              ]),
              ($setup.can('conversations.organization'))
                ? (_openBlock(), _createElementBlock("label", _hoisted_10, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($setup.shareOrg) = $event)),
                      type: "checkbox"
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelCheckbox, $setup.shareOrg]
                    ]),
                    _createTextVNode(" " + _toDisplayString($setup.state.t("conv.share_org")), 1 /* TEXT */)
                  ]))
                : _createCommentVNode("v-if", true),
              _createVNode($setup["FilePicker"], {
                modelValue: $setup.files,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($setup.files) = $event)),
                max: 1
              }, null, 8 /* PROPS */, ["modelValue"]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  type: "button",
                  class: "tx-btn tx-btn--ghost",
                  onClick: _cache[5] || (_cache[5] = $event => ($setup.composing = false))
                }, _toDisplayString($setup.state.t("common.cancel")), 1 /* TEXT */),
                _createElementVNode("button", {
                  class: "tx-btn tx-btn--primary",
                  disabled: $setup.busy
                }, _toDisplayString($setup.state.t("conv.start")), 9 /* TEXT, PROPS */, _hoisted_12)
              ])
            ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_7))
          : ($setup.activeId)
            ? (_openBlock(), _createBlock($setup["Loader"], {
                key: 1,
                loading: $setup.loadingThread && !$setup.thread,
                error: $setup.threadError,
                onRetry: $setup.loadThread
              }, {
                default: _withCtx(() => [
                  ($setup.thread)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("header", _hoisted_13, [
                          _createElementVNode("a", {
                            href: $setup.link('conversations'),
                            "data-nav": "",
                            class: "tx-backlink tx-only-sm"
                          }, [
                            _createVNode($setup["Icon"], {
                              name: "back",
                              size: "16"
                            })
                          ], 8 /* PROPS */, _hoisted_14),
                          _createElementVNode("div", null, [
                            _createElementVNode("h2", null, _toDisplayString($setup.thread.conversation.subject), 1 /* TEXT */),
                            _createElementVNode("small", _hoisted_15, [
                              ($setup.state.provider === 'Raven')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString($setup.state.t("conv.provider_raven")), 1 /* TEXT */)
                                  ], 64 /* STABLE_FRAGMENT */))
                                : _createCommentVNode("v-if", true),
                              ($setup.thread.conversation.helpdesk_ticket)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 1,
                                    href: $setup.link('tickets/' + $setup.thread.conversation.helpdesk_ticket),
                                    "data-nav": ""
                                  }, " · " + _toDisplayString($setup.state.t("conv.escalated")) + " #" + _toDisplayString($setup.thread.conversation.helpdesk_ticket), 9 /* TEXT, PROPS */, _hoisted_16))
                                : _createCommentVNode("v-if", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            ($setup.state.modules.tickets && !$setup.thread.conversation.helpdesk_ticket && $setup.thread.conversation.status !== 'Closed')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "tx-btn tx-btn--ghost tx-btn--sm",
                                  disabled: $setup.busy,
                                  onClick: $setup.escalate
                                }, _toDisplayString($setup.state.t("conv.escalate")), 9 /* TEXT, PROPS */, _hoisted_18))
                              : _createCommentVNode("v-if", true),
                            ($setup.thread.conversation.status !== 'Closed')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  class: "tx-btn tx-btn--ghost tx-btn--sm",
                                  disabled: $setup.busy,
                                  onClick: $setup.close
                                }, _toDisplayString($setup.state.t("conv.close")), 9 /* TEXT, PROPS */, _hoisted_19))
                              : _createCommentVNode("v-if", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.thread.messages, (m) => {
                            return (_openBlock(), _createElementBlock("article", {
                              key: m.id,
                              class: _normalizeClass(["tx-bubble", m.from_customer ? 'tx-bubble--me' : 'tx-bubble--them'])
                            }, [
                              _createElementVNode("small", null, _toDisplayString(m.is_me ? $setup.state.t("tickets.you") : m.author) + " · " + _toDisplayString($setup.fmtDate(m.created, true)), 1 /* TEXT */),
                              _createElementVNode("div", {
                                class: "tx-prose",
                                innerHTML: m.content
                              }, null, 8 /* PROPS */, _hoisted_21),
                              (m.has_attachment)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    href: $setup.downloadUrl('conversations.download_attachment', { message: m.id }),
                                    class: "tx-chip"
                                  }, [
                                    _createVNode($setup["Icon"], {
                                      name: "paperclip",
                                      size: "14"
                                    }),
                                    _createTextVNode(_toDisplayString(m.attachment_name), 1 /* TEXT */)
                                  ], 8 /* PROPS */, _hoisted_22))
                                : _createCommentVNode("v-if", true)
                            ], 2 /* CLASS */))
                          }), 128 /* KEYED_FRAGMENT */))
                        ], 512 /* NEED_PATCH */),
                        ($setup.thread.conversation.status === 'Closed')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString($setup.state.t("conv.closed")), 1 /* TEXT */))
                          : (_openBlock(), _createElementBlock("form", {
                              key: 1,
                              class: "tx-composer",
                              onSubmit: _withModifiers($setup.send, ["prevent"])
                            }, [
                              _withDirectives(_createElementVNode("textarea", {
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($setup.draft) = $event)),
                                rows: "2",
                                placeholder: $setup.state.t('conv.type_message'),
                                "aria-label": $setup.state.t('conv.type_message'),
                                maxlength: "20000",
                                onKeydown: _withKeys(_withModifiers($setup.send, ["exact","prevent"]), ["enter"])
                              }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_25), [
                                [_vModelText, $setup.draft]
                              ]),
                              _createElementVNode("div", _hoisted_26, [
                                _createVNode($setup["FilePicker"], {
                                  modelValue: $setup.files,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (($setup.files) = $event)),
                                  max: 1
                                }, null, 8 /* PROPS */, ["modelValue"]),
                                _createElementVNode("button", {
                                  class: "tx-btn tx-btn--primary",
                                  disabled: $setup.busy || (!$setup.draft.trim() && !$setup.files.length)
                                }, _toDisplayString($setup.state.t("common.send")), 9 /* TEXT, PROPS */, _hoisted_27)
                              ])
                            ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_24))
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["loading", "error"]))
            : (_openBlock(), _createBlock($setup["Empty"], {
                key: 2,
                icon: "chat",
                text: $setup.state.t('conv.empty')
              }, null, 8 /* PROPS */, ["text"]))
      ])
    ], 2 /* CLASS */)
  ]))
}